import styled from 'styled-components';
import { IconButton } from '../Button/IconButton';
import React, { useCallback } from 'react';
import Menu from '../Menu/Menu';
import { HudIcon, HudIconProps } from '../Icons/HudIcons';
import { LeftSection } from './CopyMenu.styles';

export type CopyMenuProps = {
  // value: string;
  copyableItems: {
    icon?: HudIconProps['icon'];
    leftSection?: React.ReactNode;
    label: string;
    value: string;
  }[];
  className?: string;
};

export const TopMenu = styled(Menu.Menu).attrs({ position: 'top' })``;

const StyledButton = styled(IconButton)`
  padding: 4px;
`;

export function CopyMenu({ className, copyableItems }: CopyMenuProps) {
  const handleCopy = useCallback((value: string) => {
    navigator.clipboard.writeText(value);
  }, []);

  return (
    <TopMenu>
      <Menu.Target>
        <div>
          <StyledButton icon="other.copy" size="sm" />
        </div>
      </Menu.Target>
      <Menu.Dropdown className={className}>
        {copyableItems.map(({ label, value, icon, leftSection }) => (
          <Menu.Item
            leftSection={
              icon || leftSection ? (
                <LeftSection>
                  {icon ? <HudIcon icon={icon} size="16px" /> : null}
                  {leftSection ? leftSection : null}
                </LeftSection>
              ) : null
            }
            onClick={() => handleCopy(value)}
            key={label}
          >
            Copy {label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </TopMenu>
  );
}
